import React from 'react'

import { Link } from '@reach/router'

import { useSessionContext } from 'components/sessions/sessionContext'
import MainLayout from 'app/MainLayout'
import CreateUser from './CreateUserForm'
import UpgradeUser from './UpgradeUserForm'

const Register = () => {
  const { isGuest } = useSessionContext()
  return (
    <MainLayout>
      <h1>{isGuest ? 'Register for free' : 'Register'}</h1>
      <p>
        Got an account? <Link to="/login">login</Link>
      </p>
      {isGuest ? <UpgradeUser /> : <CreateUser />}
    </MainLayout>
  )
}

export default Register
